export default __webpack_public_path__ + "assets/fcf378907e65083b213b5f436a451a9d.jpeg";